import { render, staticRenderFns } from "./AIRandomTextMessage.vue?vue&type=template&id=6118e27a&scoped=true"
import script from "./AIRandomTextMessage.vue?vue&type=script&lang=js"
export * from "./AIRandomTextMessage.vue?vue&type=script&lang=js"
import style0 from "./AIRandomTextMessage.vue?vue&type=style&index=0&id=6118e27a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6118e27a",
  null
  
)

export default component.exports